import { isCoralogixRumInitialized, logAlways, whenCoralogixRumReady } from './coralogix-rum';

const loggedFallbacks = new Set<string>();
const pendingFallbacks = new Map<string, { provider: string; paymentMethod: string }>();

const PSP_KEY_TOP_LEVEL_FALLBACK = 'Checkout PSP key fell back to top-level pks';

const flushPendingFallbacks = (): void => {
  if (!isCoralogixRumInitialized()) return;
  pendingFallbacks.forEach((source, dedupeKey) => {
    logAlways(PSP_KEY_TOP_LEVEL_FALLBACK, source);
    loggedFallbacks.add(dedupeKey);
  });
  pendingFallbacks.clear();
};

whenCoralogixRumReady(flushPendingFallbacks);

/**
 * Method key wins. The top-level publisher key is the fallback, and that path
 * is logged once per provider and payment method. The log waits until Coralogix
 * RUM is initialized, because v2 drops logs sent before init.
 */
export function getPaymentKey(
  methodKey: string | undefined,
  topLevelKey: string | undefined,
  source: { provider: string; paymentMethod: string },
): string | undefined {
  const resolvedKey = methodKey || topLevelKey;
  if (!methodKey && resolvedKey) {
    const dedupeKey = `${source.provider}:${source.paymentMethod}`;
    if (!loggedFallbacks.has(dedupeKey) && !pendingFallbacks.has(dedupeKey)) {
      pendingFallbacks.set(dedupeKey, source);
      flushPendingFallbacks();
    }
  }
  return resolvedKey;
}
